import * as React from 'react';
import { Helmet } from 'react-helmet';
import { LastUpdated } from '../components/LastUpdated';
import { Container } from '../components/ui/Container';
import { CSSReset, Theme } from '../components/ui/Theme';
import { WorldDailyCases } from '../components/WorldDailyCases';
import { WorldSummary } from '../components/WorldSummary';

const IndexPage = () => {
  return (
    <Theme>
      <CSSReset />
      <Helmet>
        <title>Overview · COVID-19</title>
      </Helmet>
      <Container>
        <div style={{ margin: '16px 0' }}>
          <h1>COVID-19 Overview</h1>
        </div>
        <div style={{ margin: '24px 0' }}>
          <WorldDailyCases />
        </div>
        <div style={{ margin: '24px 0' }}>
          <WorldSummary />
        </div>
        <p>
          <LastUpdated />
          <br />
          Contribute and suggest features on{' '}
          <a href="https://github.com/South-Paw/covid-19" target="_blank" rel="noopener noreferrer">
            Github
          </a>
          <br />
          Data sourced from <a href="https://github.com/CSSEGISandData/COVID-19">JHU CSSE</a>
        </p>
      </Container>
    </Theme>
  );
};

export default IndexPage;
